import { Link } from "react-router-dom";
import LSSDLogo from "./LSSDLogo";
import { ExternalLink } from "lucide-react";

const FOOTER_LINKS = [
  {
    title: "Dipartimento",
    items: [
      { to: "/storia", label: "La Nostra Storia" },
      { to: "/roster", label: "Organico Ufficiale" },
      { to: "/codice-penale", label: "Codice Penale" },
    ],
  },
  {
    title: "Reclutamento",
    items: [
      { to: "/arruolamento", label: "Candidati Ora" },
      { to: "/candidatura", label: "Stato Candidatura" },
      { to: "/login", label: "Portale Operatori" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[var(--lssd-olive-deep)] border-t border-[var(--lssd-khaki)]/25 mt-24" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
        {/* Brand */}
        <div className="md:col-span-2 flex items-start gap-4">
          <LSSDLogo className="h-14 w-14 shrink-0" />
          <div>
            <h3 className="font-display font-black text-[var(--lssd-cream)] text-xl leading-tight">
              Los Santos County<br />Sheriff&apos;s Department
            </h3>
            <p className="text-[13px] text-[var(--lssd-cream)]/60 mt-2 max-w-sm leading-relaxed">
              Al servizio della Contea di Los Santos dal 1852. Sette divisioni operative,
              una sola missione: <span className="text-[var(--lssd-khaki)]">Honor · Integrity · Service</span>.
            </p>
            <div className="mt-4 text-[10px] font-mono uppercase tracking-[0.24em] text-[var(--lssd-khaki)]">
              A Tradition of Service Since 1852
            </div>
          </div>
        </div>

        {/* Link cols */}
        {FOOTER_LINKS.map((col) => (
          <div key={col.title}>
            <h4 className="text-[10px] font-semibold uppercase tracking-[0.24em] text-[var(--lssd-khaki)] mb-4">
              {col.title}
            </h4>
            <ul className="space-y-2.5 text-sm">
              {col.items.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-[var(--lssd-cream)]/75 hover:text-[var(--lssd-khaki)] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[var(--lssd-khaki)]/15">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-5 flex flex-wrap items-center justify-between gap-3">
          <p className="text-[11px] text-[var(--lssd-cream)]/50">
            © {new Date().getFullYear()} LSSD Roleplay Community. Esperienza di Roleplay non affiliata a enti reali.
          </p>
          <a
            href="https://discord.gg/JQE6UTAuP9"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 text-[11px] text-[var(--lssd-khaki)] hover:text-[var(--lssd-cream)] transition-colors"
          >
            <ExternalLink className="h-3 w-3" /> Community Discord
          </a>
        </div>
      </div>
    </footer>
  );
}
